'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import Sidebar from './Sidebar';

/**
 * DashboardShell — persistent sidebar wrapper.
 * 
 * Lives in root layout so the Sidebar NEVER unmounts during
 * dashboard-to-dashboard navigation, eliminating blank-flash glitches.
 * 
 * Public routes (/home, /login, /[slug]) render children without the shell.
 */

const DASHBOARD_PREFIXES = [
  '/dashboard',
  '/scraper',
  '/leads',
  '/digital-assets',
  '/whats-app-broadcast-management',
  '/pipeline-editor',
  '/live-chat',
  '/projects',
  '/tasks',
  '/invoices',
  '/users',
  '/reports',
  '/settings',
  '/api-automation',
  '/lp-management',
  '/gallery',
];

function isDashboardRoute(pathname: string): boolean {
  return DASHBOARD_PREFIXES.some(p => pathname === p || pathname.startsWith(p + '/'));
}

export default function DashboardShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  if (!isDashboardRoute(pathname)) {
    return <>{children}</>;
  }

  return (
    <div className="flex h-screen overflow-hidden bg-[#1c1c1c]" suppressHydrationWarning>
      <Sidebar />
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden py-2 px-2 md:pl-0 lg:py-3 lg:pr-3 lg:pl-0" suppressHydrationWarning>
        <div
          className="flex flex-col flex-1 min-w-0 overflow-hidden rounded-[var(--radius)]"
          style={{ background: 'var(--background)' }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
